import logger from '../../utils/logger';
import { api } from './client';

export const siteApi = {
  getSites: async (orgId?: string) => {
    const url = orgId ? `/sites?orgId=${orgId}` : '/sites';
    logger.log('🏢 getSites:', { url, orgId });
    const response = await api.get(url);
    logger.log('✅ getSites response:', response.data?.length || 0, 'sites');
    return response.data;
  },

  createSite: async (data: any) => {
    const response = await api.post('/sites', data);
    return response.data;
  },

  updateSite: async (siteId: string, data: any) => {
    const response = await api.patch(`/sites/${siteId}`, data);
    return response.data;
  },

  deleteSite: async (siteId: string) => {
    const response = await api.delete(`/sites/${siteId}`);
    return response.data;
  },
};
